import { BoxProps, ModBox, Spacer, SpacerNew, TextNew } from '@jfs/ui-new'
import { useState } from 'react'
import { Switch } from 'react-native'
import { ExpandAddView } from '../../components/ExpandAddView'
import { useStores } from '../../data/store'
import { ApprovalTypes } from '../../utils/constants'
import { MasterApprovals } from '../EntityApprovals/MasterApprovals'
import { EssAuditTrials } from '../EssAuditTrials'
import { BulkPackageToMidApproval } from './BulkPackageToMidApproval'

const RoutingApprovals = () => {
  const {
    packageApproval,
    midpkgMappingApproval,
    packageFileUploadApproval,
    hasAuditAccess,
    isAccessConfigPriviledged,
  } = useStores((store) => ({
    packageApproval: store.user.getAccessConfig(['routing', 'package', 'approve', 'isAccessible']),
    midpkgMappingApproval: store.user.getAccessConfig(['routing', 'mid_package_mapping', 'approve', 'isAccessible']),
    packageFileUploadApproval: store.user.getAccessConfig([
      'routing',
      'package_file_upload',
      'approve',
      'isAccessible',
    ]),
    hasAuditAccess: store.user.getAccessConfig(['sys_control_config', 'audit', 'approval_audit_fetch', 'isAccessible']),
    isAccessConfigPriviledged: store.user.getAccessConfig([
      'sys_control_config',
      'audit',
      'approval_audit_privileged',
      'isAccessible',
    ]),
  }))

  const [isUserApprover, setUserApprover] = useState(false)

  const handleToggle = (val: boolean) => {
    setUserApprover(val)
  }
  return (
    <ModBox>
      <ModBox {...styles.container} show={packageApproval}>
        <ExpandAddView title={'Package Creation Approvals'}>
          <MasterApprovals type={ApprovalTypes.PACKAGE} />
        </ExpandAddView>
      </ModBox>
      <Spacer direction="vertical" size={24} />
      <ModBox {...styles.container} show={midpkgMappingApproval}>
        <ExpandAddView title={'Merchant Id to Package Approvals'}>
          <MasterApprovals type={ApprovalTypes.PACKAGE_MID} title="Merchant Id to Package Approvals" hideTitle={true} />
        </ExpandAddView>
      </ModBox>
      <Spacer direction="vertical" size={24} />
      <ModBox {...styles.container} show={midpkgMappingApproval}>
        <ExpandAddView title={'Bulk Merchant Id to Package Approvals'}>
          <BulkPackageToMidApproval />
        </ExpandAddView>
      </ModBox>
      <Spacer direction="vertical" size={24} />
      <ModBox {...styles.container} show={packageFileUploadApproval}>
        <ExpandAddView title={'Routing File Upload Approvals'}>
          <MasterApprovals type={ApprovalTypes.FILE_ROUTING} />
        </ExpandAddView>
      </ModBox>
      <Spacer direction="vertical" size={24} />
      <ModBox
        show={!isAccessConfigPriviledged && hasAuditAccess}
        p={40}
        align={'center'}
        justify={'flex-end'}
        flexDirection={'row'}>
        <TextNew title={'User'} fontFamily={'jiotype-medium'} fontSize={16} color={'BLACK_21'} />
        <SpacerNew direction={'horizontal'} size={12} />
        <Switch onValueChange={handleToggle} value={isUserApprover} />
        <SpacerNew direction={'horizontal'} size={12} />
        <TextNew title={'Approver'} fontFamily={'jiotype-medium'} fontSize={16} color={'BLACK_21'} />
      </ModBox>
      <Spacer direction="vertical" size={24} />
      <ModBox {...styles.container} show={hasAuditAccess}>
        <ExpandAddView title={'Package Creation Approvals - Audit Trail'}>
          <EssAuditTrials type={ApprovalTypes.ROUTING_PACKAGE_CONFIG_AUD_TRIAL} isApprover={isUserApprover} />
        </ExpandAddView>
      </ModBox>
      <Spacer direction="vertical" size={24} />
      <ModBox {...styles.container} show={hasAuditAccess}>
        <ExpandAddView title={'Merchant Id to Package Approvals - Audit Trail'}>
          <EssAuditTrials type={ApprovalTypes.ROUTING_MID_PACKAGE_CONFIG_AUD_TRIAL} isApprover={isUserApprover} />
        </ExpandAddView>
      </ModBox>
      <Spacer direction="vertical" size={24} />
      <ModBox {...styles.container} show={hasAuditAccess}>
        <ExpandAddView title={'Routing File Upload Approvals - Audit Trail'}>
          <EssAuditTrials type={ApprovalTypes.ROUTING_FILE_UPLOAD_AUD_TRIAL} isApprover={isUserApprover} />
        </ExpandAddView>
      </ModBox>
    </ModBox>
  )
}

export default RoutingApprovals

const styles = {
  container: {
    backgroundColor: 'WHITE',
  } as BoxProps,
  subcontainer: {
    backgroundColor: 'WHITE',
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 16,
  } as BoxProps,
}
